import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import Axios from "axios";
import { Accordion, Card, Button } from "react-bootstrap";
import MySchedule from "./MySchedule";
import MessageModal from "./modals/MessageModal";
import HelpDeskModal from "./modals/HelpDeskModal";
import firebase from "../../Firebase/index";

const Lobby = () => {
  const [sponserImg, setSponserImg] = useState([]);
  const [slideToShowImgCount, setSlideToShowImgCount] = useState(1);
  const [myScheduleModal, setMyScheduleModal] = useState(false);
  const [helpDeskModal, setHelpDeskModal] = useState(false);
  const [helpDeskContents, setHelpDeskContents] = useState([]);
  const [messageModal, setMessageModal] = useState(false);
  const [userMessages, setUserMessages] = useState([]);
  const [localAttraction, setLocalAttraction] = useState(null);
  const [allowAsExhibitor, setAllowAsExhibitor] = useState(false);
  const [allowAsSpeaker, setAllowAsSpeaker] = useState(false);
  const [allowAttendee, setAllowAttendee] = useState(false);
  const { id } = useParams();
  const eventId = localStorage.getItem("eventId");

  useEffect(() => {
    getSliderData();
    getLocalAttraction();
    var rolesArr = localStorage.getItem("currentRole").split(",");
    if (rolesArr.indexOf("-1") !== -1) {
      setAllowAsExhibitor(true);
    }
    if (rolesArr.indexOf("-6") !== -1) {
      setAllowAsSpeaker(true);
    }
    if (rolesArr.indexOf("111") !== -1) {
      setAllowAttendee(true);
    }
  }, []);

  useEffect(() => {
    if (helpDeskModal) getHelpDeskData();
    if (messageModal) getEventMessages();
    // return () => {
    //   setHelpDeskContents([])
    // }
  }, [helpDeskModal, messageModal]);

  useEffect(() => {
    if (/iPhone|iPad|Mac|Macintosh|iPod/i.test(navigator.userAgent)) {
      console.log("yes apple");
    } else {
      if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        const messaging = firebase.messaging();
        messaging
          .getToken()
          .then((token) => {
            saveFirebasePushNotificationToken(token);
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          if (permission === "granted") {
            const messaging = firebase.messaging();
            messaging
              .getToken()
              .then((token) => {
                const tokData = {
                  token: token,
                  email: localStorage.getItem("username"),
                };

                Axios.post(
                  `${global.config.requestUrl}saveFirebaseToken`,
                  tokData,
                  {
                    headers: {
                      "auth-token": localStorage.getItem("exhibitorToken"),
                    },
                  }
                )
                  .then((res) => {})
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      }
    }
  }, []);

  const saveFirebasePushNotificationToken = (token) => {
    const tokData = {
      token: token,
      email: localStorage.getItem("username"),
    };

    Axios.post(`${global.config.requestUrl}saveFirebaseToken`, tokData, {
      headers: { "auth-token": localStorage.getItem("exhibitorToken") },
    })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  //Get slider images data
  const getSliderData = () => {
    Axios.get(
      `${global.config.requestUrl}exhibitor?eventId=${eventId}&type=1`
    ).then((res) => {
      if (res.data.errorCode === 0) {
        setSponserImg(res.data.data);
        if (res.data.data.length > 1) setSlideToShowImgCount(2);
      } else {
        setSponserImg([
          {
            logo: process.env.PUBLIC_URL + "/images/sponser-dummy.png",
            exhibitor_id: null,
          },
        ]);
      }
    });
  };

  //Get Information data
  const getHelpDeskData = () => {
    Axios.get(
      `${global.config.requestUrl}user/getHelpDeskContent?eventId=${eventId}`,
      { headers: { "auth-token": localStorage.exhibitorToken } }
    )

      .then((res) => {
        if (!res.data.errorCode) setHelpDeskContents(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
//Get Event Messages data
  const getEventMessages = () => {
    Axios.get(
      `${global.config.requestUrl}user/getEventMessages?eventId=${eventId}`,
      {
        headers: { "auth-token": localStorage.exhibitorToken },
      }
    )
      .then((res) => {
        if (res.data.errorCode === 0) setUserMessages(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLocalAttraction = () => {
    Axios.get(
      `${global.config.requestUrl}getLocalAttraction?eventId=${eventId}`,
      {
        headers: { "auth-token": localStorage.exhibitorToken },
      }
    )
      .then((res) => {
        if (res.data.errorCode === 0) setLocalAttraction(res.data.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Handle My Schedule modal
  const myScheduleModalHandler = (e) => {
    e.preventDefault();
    setMyScheduleModal(!myScheduleModal);
  };

  //Handle Information modal
  const helpDeskModalHandler = (e) => {
    e.preventDefault();
    setHelpDeskModal(!helpDeskModal);
  };

  //Handle Event Messages Modal
  const messageModalHandler = (e) => {
    e.preventDefault();
    setMessageModal(!messageModal);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slideToShowImgCount,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    vertical: false,
  };
  return (
    <React.Fragment>
      <div className="p-3">
        {/* <div className="card py-2 px-3 border-none box-shadow mt-3">
          <div className="scroller">
            <Slider {...settings}>
              {sponserImg.map((sponsor, index) => (
                <div className="card" key={index}>
                  <img src={sponsor.logo} alt="" />
                </div>
              ))}
            </Slider>
          </div>
        </div> */}
        <div className="card p-3 border-none box-shadow">
          <div className="twoSideList grey-box">
            <Link to="/mdapa2024/conference" className="customBtn mt-1 halfBtn">
              Conference Schedule
            </Link>
            <Link to="/mdapa2024/sponsors" className="customBtn mt-1 halfBtn">
              Sponsors
            </Link>
            <Link to="/mdapa2024/speakers" className="customBtn mt-1 halfBtn">
              Speakers
            </Link>
            <Link
              to="/mdapa2024/attendee/exhibitHall"
              className="customBtn mt-1 halfBtn"
            >
              Exhibitors
            </Link>
            <Link to="/mdapa2024/maps" className="customBtn mt-1 halfBtn">
              Maps
            </Link>
            <a
              rel="noopener noreferrer"
              className="customBtn mt-1 halfBtn"
              href={localAttraction ? localAttraction?.url : "/mdapa2024/lobby"}
              target="_blank"
            >
              Local Attractions
            </a>
            {/* <Link to={localAttraction ? localAttraction?.url : '/tobi2022/lobby'} className="customBtn mt-1 halfBtn">
            Local Attractions
          </Link> */}
            <Link
              to="/"
              onClick={messageModalHandler}
              className="customBtn mt-1 halfBtn"
            >
              Event Messages
            </Link>
            <Link to="/mdapa2024/attendees" className="customBtn mt-1 halfBtn">
              Attendees
            </Link>
            <Link
              to="/"
              onClick={myScheduleModalHandler}
              className="customBtn mt-1 halfBtn"
            >
              My Schedule
            </Link>
            <Link
              to="/"
              onClick={helpDeskModalHandler}
              className="customBtn mt-1 halfBtn"
            >
              Information
            </Link>
            <Link
              to={
                allowAsExhibitor
                  ? "exhibitor/profile"
                  : allowAsSpeaker
                  ? "speaker/profile"
                  : "/mdapa2024/user/profile"
              }
              className="customBtn mt-1 halfBtn"
            >
              Profile
            </Link>
              
            <a
              rel="noopener noreferrer"
              className="customBtn mt-1 halfBtn"
              href={"https://www.32auctions.com/mdapa2024"}
              target="_blank"
            >
              Silent Auction
            </a>

            <a
              rel="noopener noreferrer"
              className="customBtn mt-1 halfBtn"
              href={"https://www.tslwebreg.com/certificate.php?user_id=920&event_id=1131"}
              target="_blank"
            >
              CME Certificate
            </a>

          </div>
        </div>
        {myScheduleModal ? (
          <div className="midModal">
            {/* <div className="modalOverlay" onClick={myScheduleModalHandler}></div> */}
            <div className="midContentWrp">
              <div
                className="modalPopUpClose"
                id="myschedulepopup"
                onClick={myScheduleModalHandler}
              >
                <i className="fa fa-times"></i>
              </div>
              <MySchedule />
            </div>
          </div>
        ) : null}
        {helpDeskModal ? (
          <HelpDeskModal
            closeModal={helpDeskModalHandler}
            helpDeskContents={helpDeskContents}
          />
        ) : null}
        {messageModal ? (
          <MessageModal
            closeModal={messageModalHandler}
            userMessages={userMessages}
          />
        ) : null}

        <div className="border-none mt-3">
          <div className="twoSideList">
            {sponserImg.map((sponsor, index) => (
              <div className="card" key={index}>
                {sponsor.link ? (
                  <a href={sponsor.link} target="_blank">
                    <img src={sponsor.logo} alt="" />
                  </a>
                ) : (
                  <img src={sponsor.logo} alt="" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Lobby;
